import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_sbY0NWq9GMkz: {
	id: 'prd_sbY0N2DEV2Wq9GMkz'
	ident: 'prd_sbY0NWq9GMkz'
	sku: 'simple_premium_1m_9_99_1m_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'month'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_wlCKe2DEV28kScff1'
			amount: 44
			amount_usd: 9.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 9.99
			discount: 34.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'month'
			interval_duration: 1
			iteration_count: null
			price_id: 'prc_tqSa52DEV24sUAM3I'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_sbY0NWq9GMkz, SubscriptionProduct>
const prd_sbY0NWq9GMkz = { ident: 'prd_sbY0NWq9GMkz' } as typeof _prd_sbY0NWq9GMkz

export default prd_sbY0NWq9GMkz
